import React, {useEffect, useContext, useState} from 'react';

import {AuthContext} from '../../context';
import {getCompany, getServices, updateCompany, archivedCompany} from '../../api';
import {PageContainer, FormAdmin, Notification} from '../../components';

const Customer = ({match}) => {
  const {user} = useContext(AuthContext);
  const [services, setServices] = useState();
  const [loading, setLoading] = useState(true);
  const [companyName, setCompanyName] = useState('');
  const [isArchived, setIsArchived] = useState('');
  const [endOfUseDate, setEndOfUseDate] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenModalToArchive, setIsOpenModalToArchive] = useState(false);
  const [team, setTeam] = useState();
  const [notif, setNotif] = useState();
  const companyId = match.params.id;

  const handleCompanyInfos = async () => {
    try {
      const data = await getCompany(companyId);
      const allServices = await getServices();

      setCompanyName(data.name);
      setIsArchived(data.isArchived);
      setTeam(data.team);
      const formattedDate = data.endOfUseDate.split('T');
      setEndOfUseDate(formattedDate[0]);

      const servicesTemp = [];
      for (let i = 0; i < allServices.length; i++) {
        const checkServiceInUser = data.services?.find(
          (serviceUser) => serviceUser.service == allServices[i]._id
        );
        servicesTemp.push({
          value: allServices[i]._id,
          label: allServices[i].name,
          credits: checkServiceInUser ? checkServiceInUser.credits : '',
          isSelected: checkServiceInUser ? true : false,
          unlimited: checkServiceInUser ? checkServiceInUser.unlimited : false,
          monthlyMonitoring: checkServiceInUser && checkServiceInUser.monthlyMonitoring,
        });
      }
      setServices(servicesTemp);

      setLoading(false);
    } catch (err) {
      return err;
    }
  };

  const changeTeam = (e, teammateIndex) => {
    const copyTeammate = [...team];
    copyTeammate[teammateIndex][e.target.name] = e.target.value;
    setTeam(copyTeammate);
  };

  const changeServices = (e, index) => {
    const copy = [...services];
    copy[index].isSelected = !copy[index].isSelected;
    setServices(copy);
  };

  const changeCredits = (e, index) => {
    const copy = [...services];
    copy[index][e.target.name] = e.target.value;
    setServices(copy);
  };

  const changeUnlimited = (e, index) => {
    const copy = [...services];
    copy[index].unlimited = !copy[index].unlimited;
    copy[index].credits = copy[index].unlimited && 0;
    setServices(copy);
  };

  const addTeammate = (e) => {
    e.preventDefault();
    setTeam([
      ...team,
      {
        firstname: '',
        lastname: '',
        email: '',
        profession: '',
        phone: '',
      },
    ]);
  };

  const removeTeammate = (e, index) => {
    const filtered = team.filter((t) => t !== team[index]);
    setTeam(filtered);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNotif();

    const formattedServices = [];
    services.map((s) => {
      s.isSelected &&
        formattedServices.push({
          service: s.value,
          credits: parseInt(s.credits, 10),
          unlimited: s.unlimited,
          monthlyMonitoring: s.monthlyMonitoring,
        });
    });

    const data = await updateCompany(companyId, {
      name: companyName,
      endOfUseDate,
      team,
      services: formattedServices,
    });
    setNotif({
      type: 'success',
      text: data.msg,
    });

    if (data.error)
      return setNotif({
        type: 'error',
        text: data.error,
      });
  };

  const handleArchivedCompany = async (isArchivedValue) => {
    const formattedServices = [];
    services.map((s) => {
      s.isSelected &&
        formattedServices.push({
          service: s.value,
          credits: 0,
          unlimited: false,
          monthlyMonitoring: s.monthlyMonitoring,
        });
    });

    const data = await archivedCompany(companyId, isArchivedValue, formattedServices);
    setIsArchived(!isArchived);
    setIsOpenModalToArchive(false);

    if (data.error)
      return setNotif({
        type: 'error',
        text: data.error,
      });
  };

  useEffect(() => {
    handleCompanyInfos();
  }, [companyId]);

  if (loading) return <p>loading</p>;
  return (
    <div>
      <PageContainer role={user.infos.role} companyName="Sublissime" title={companyName}>
        <FormAdmin
          companyId={companyId}
          isArchived={isArchived}
          isOpenModalToArchive={isOpenModalToArchive}
          changeIsOpenModalToArchive={setIsOpenModalToArchive}
          services={services}
          changeServices={changeServices}
          changeCredits={changeCredits}
          changeUnlimited={changeUnlimited}
          changeCompanyName={setCompanyName}
          changeDate={setEndOfUseDate}
          changeTeam={changeTeam}
          changeIsOpen={setIsOpen}
          addTeammate={addTeammate}
          removeTeammate={removeTeammate}
          companyName={companyName}
          team={team}
          endOfUseDate={endOfUseDate}
          isOpen={isOpen}
          handleSubmit={handleSubmit}
          handleArchivedCompany={handleArchivedCompany}
        />
        {notif && <Notification type={notif.type} text={notif.text} />}
      </PageContainer>
    </div>
  );
};

export default Customer;
